import React from "react";

function App() {
  return <div>{/* Blank page */}</div>;
}

export default App;
